import { render } from "./BenchmarkViewWiland.vue?vue&type=template&id=c93420d4"
import script from "./BenchmarkViewWiland.vue?vue&type=script&lang=js"
export * from "./BenchmarkViewWiland.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/BenchmarkViewWiland.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c93420d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c93420d4', __exports__)) {
    api.reload('c93420d4', __exports__)
  }
  
  module.hot.accept("./BenchmarkViewWiland.vue?vue&type=template&id=c93420d4", () => {
    api.rerender('c93420d4', render)
  })

}


export default __exports__